/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichTextComponent } from "../rich-text/rich-text";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { ProcessCardsItem } from "./process-cards-item";
import { ReactComponent as CardSeparatorIcon } from "cms/assets/icons/triangle-right.svg";

const ProcessCardsComponent = (props) => {
    const component = props?.component;
    const title = component?.title ?? "";
    const description = component?.description;
    const cardList = component?.list ?? [];

    return (
        <div className='process-cards-component'>
            {title && <h2>{title}</h2>}
            {description && <RichTextComponent component={{ richtext: description }} />}
            {isArrayNotEmpty(cardList) && (
                <div className='process-cards-container'>
                    {cardList.map((item, index) => {
                        const isLastCard = index === (cardList.length - 1);
                        const key = `process-card${item?.stepNumber}-${index}`;
                        return (
                            <div key={key}>
                                <ProcessCardsItem
                                    item={item}
                                />
                                {!isLastCard && <CardSeparatorIcon alt="triangle" />}
                            </div>
                        );
                    }
                    )}
                </div>
            )}
        </div>
    );
};

ProcessCardsComponent.displayName = "ProcessCardsComponent";
export { ProcessCardsComponent };
